import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/families')({
  component: FamiliesLayout,
});

function FamiliesLayout() {
  return <Outlet />;
}

// Allow nested routes:
//   /admin/families         → list
//   /admin/families/new     → new-family form
//   /admin/families/import  → CSV wizard
//   /admin/families/$id     → detail
//
// Each is its own file under apps/web/src/routes/admin.families.*.tsx so
// TanStack Router can code-split each route.
